<div
  class="cf-field"
  [class.cf-field--full]="field.fullWidth"
  [class.cf-field--error]="showErrors"
  [formGroup]="form"
>
  <!-- Custom components (e.g. intl-tel-input for phone, the "Otro" select for select_other) -->
  <app-phone-field
    *ngIf="field.component === COMPONENT.PHONE"
    [formControlName]="field.controlName"
    [required]="state?.required || false"
  ></app-phone-field>

  <app-select-other-field
    *ngIf="field.component === COMPONENT.SELECT_OTHER"
    [formControlName]="field.controlName"
    [label]="label"
    [options]="field.options"
    [placeholder]="field.placeholder || SELECT_OTHER.PLACEHOLDER"
  ></app-select-other-field>

  <ng-container [ngSwitch]="field.type" *ngIf="!field.component">
    <app-fh-select
    *ngSwitchCase="TYPE.SELECT"
    [formControlName]="field.controlName"
    [label]="label"
    [options]="field.options"
    [dataSource]="dataSource"
    [optionResolver]="optionResolver"
    [multiple]="field.multiple"
    [search]="searchable"
    [showEditIcon]="field.service === SERVICE_TYPE.CONTACT"
    (editOption)="onFhEditOption($event)"
  ></app-fh-select>

  <one-input
    *ngSwitchCase="TYPE.NUMBER"
    type="number"
    [formControlName]="field.controlName"
    [label]="label"
    [placeholder]="field.placeholder || ''"
    [min]="field.min"
    [max]="field.max"
    [attr.step]="step"
  ></one-input>

  <textarea
    *ngSwitchCase="TYPE.TEXTAREA"
    class="cf-textarea"
    rows="4"
    [formControlName]="field.controlName"
    [placeholder]="field.label"
  ></textarea>

  <app-fh-select
    *ngSwitchCase="TYPE.BOOLEAN"
    [formControlName]="field.controlName"
    [label]="label"
    [options]="field.options"
  ></app-fh-select>

    <!-- STRING and any unrecognised type. Never renders nothing: an unknown type degrades to text. -->
    <one-input
      *ngSwitchDefault
      [formControlName]="field.controlName"
      [label]="label"
      [placeholder]="field.placeholder || ''"
      [type]="inputType"
    ></one-input>
  </ng-container>

  <button
    *ngIf="field.underInputLabel"
    type="button"
    class="cf-field__under"
    [disabled]="!editable"
    (click)="onUnderInputClick()"
  >
    {{ field.underInputLabel }}
  </button>

  <span class="cf-field__error" *ngIf="errorMessage">{{ errorMessage }}</span>
</div>
